import React, { useEffect,useRef } from "react";
import axios from 'axios';
import jsPDF from "jspdf";
/* import makePDF from '../../../components/common/makePDF'; */
import {DrawingText,isNull,ChangeNumberFormat} from "../../../components/common/Common";

const MakePDFCertifications = ({varMakePDFFile,setMakePDFFile,varLevelList,varFileList,setFileList,varMakeList,setMakeList}) => {
  const canvaskrRef = useRef(null);
  const canvasenRef = useRef(null);

  //PDF 선언
/*   const pdf = makePDF(); */

  useEffect(() => {
    if(varMakeList.length > 0) {
      MakeCertificationFile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varMakePDFFile]);

  //수료증 이미지 생성
  const MakeCertificationFile = async() => {
    let fileList = [...varFileList];
    let newList = [...varMakeList];
    for(let i=0; i < varMakeList.length; i++) {
      let certificationData = varMakeList[i];
      //캔버스에 이미지 호출
      let contents = null;

      const backData = varLevelList.find(el=>el.vl_idx===certificationData.vl_idx);
      let fileName =  backData.vl_file;
      if(certificationData.ce_lang === 2) {
        fileName = backData.vl_efile;
        contents = canvasenRef.current.getContext('2d');
      } else {
        contents = canvaskrRef.current.getContext('2d');
      } 

      const img = new Image();
      img.src = `${process.env.REACT_APP_HOST}/certificate/${fileName}`;
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        if(certificationData.ce_lang === 2) {
          contents.drawImage(img, 0, 0, canvasenRef.current.width, canvasenRef.current.height);
        } else {
          contents.drawImage(img, 0, 0, canvaskrRef.current.width, canvaskrRef.current.height);
        }

        //글자넣기
        let issueNum = certificationData.ce_code;
        let issueDate = "20"+certificationData.ce_idate;

        let slevel = "";

        let sname = certificationData.ch_name;
        let scompany = certificationData.bh_company;
        let sbirthArray = certificationData.ch_birthday.split('.');
        let sbirthday = '20'+sbirthArray[0]+'.'+sbirthArray[1]+'.'+sbirthArray[2];
        let images = null;
        if(certificationData.ce_lang===1) { //국문
          slevel = `${certificationData.vl_name} (${certificationData.vl_terms}년수료)`;

          let info1 = {text:issueNum,x:100,y:75,fsize:10,textAlign:'left'}; DrawingText(contents,info1);
          let info2 = {text:issueDate,x:110,y:95,fsize:10,textAlign:'left'}; DrawingText(contents,info2);
          let info3 = {text:slevel,x:325,y:315,fsize:15,textAlign:'left'}; DrawingText(contents,info3);
          let info4 = {text:sname+' ( '+sbirthday+' )',x:325,y:345,fsize:15,textAlign:'left'}; DrawingText(contents,info4);
          let info5 = {text:scompany,x:490,y:370,fsize:12,textAlign:'right'}; DrawingText(contents,info5);
          images = canvaskrRef.current.toDataURL();
        } else {  //영문
          slevel = `${certificationData.vl_name} (${ChangeNumberFormat(certificationData.vl_terms)} year)`;
          sname = isNull(certificationData.ch_ename)?"":certificationData.ch_ename;
          scompany = certificationData.bh_ecompany;

          let info1 = {text:issueNum,x:100,y:123,fsize:14,textAlign:'left'}; DrawingText(contents,info1);
          let info2 = {text:issueDate,x:115,y:151,fsize:14,textAlign:'left'}; DrawingText(contents,info2);
          let info3 = {text:slevel,x:490,y:345,fsize:24,textAlign:'left'}; DrawingText(contents,info3);
          let info4 = {text:sname+' ( '+sbirthday+' / '+scompany+' )',x:540,y:425,fsize:20,textAlign:'center'}; DrawingText(contents,info4);
          images = canvasenRef.current.toDataURL();
        }
        var blobBin = atob(images.split(',')[1]);	// base64 데이터 디코딩
        var array = [];
        for (let j = 0; j < blobBin.length; j++) {
            array.push(blobBin.charCodeAt(j));
        }
        var file = new Blob([new Uint8Array(array)], {type: 'image/png'});	// Blob 생성
        //console.log(i,'333');
        UploadImageFile(certificationData,file,fileList);
      };
      newList = newList.filter(el=>el.ce_idx!==certificationData.ce_idx);
      //console.log('222');
    }
    //console.log('111');
    setMakeList(newList);
  }

  const UploadImageFile = async(certificationData,file,fileList) => {
      //수료증 이미지파일 업로드
      var formData = new FormData();	// formData 생성
      formData.append("certificate", file);
      let res1 = await axios.post(`${process.env.REACT_APP_HOST}/certificate`,formData);
      const fileName = res1.data.fileName;

      //수료증 이미지 목록에 추가
      let newData = {mode:certificationData.ce_lang,image:`${process.env.REACT_APP_HOST}/certificate/${fileName}`}
      fileList.push(newData);

      //수료증 파일명 저장
      const sendData = {ce_idx:certificationData.ce_idx,fileName:fileName};
      let res2 = await axios.post(`${process.env.REACT_APP_HOST}/_update_certificate_file`,sendData);
      console.log(res2.data);
      //console.log('444',fileList);
      setFileList(fileList);
  }

  //PDF 파일 생성
  const MakePDFFile = async() => {
    if(!window.confirm('수료증들을 PDF파일로 생성합니까?')) return false;
    //await pdf.viewWithPDF('pdf-con');
    console.log(varFileList);
    const doc = new jsPDF("p", "mm", "a4");

    const pageMax = varFileList.length;
    let j=0;
    varFileList.forEach(files=>{
      let imageMode = files.mode;
      let imageFile = files.image;
      (async () => {
        const data = await fetch(imageFile);
        const blob = await data.blob();
        const reader = new FileReader();
        reader.onload = () => {
            const base64data = reader.result;
            let orients = "portrait";
            if(imageMode ===2) orients = "landscape";
            doc.addPage("a4",orients);
            let pageWidth = doc.internal.pageSize.getWidth();
            let pageHeight = doc.internal.pageSize.getHeight();
            doc.addImage(base64data, "JPEG", 0, 0, pageWidth, pageHeight);
            j++;
            //console.log(j,pageMax,'1111');

            if(j === pageMax)  {
              //console.log('2222');
              window.open(doc.output("bloburl"))
              const pdf = new File([doc.output("blob")], "수료증.pdf", {
                  type: "application/pdf",
              });
              console.log(pdf);
            }
        }
        reader.readAsDataURL(blob);
      })();
    });
  }

  return !varMakePDFFile?null:(
    <div className={varMakePDFFile?"layer__pop open":"layer__pop"}>
      <div className="layer__pop__confirm" style={{maxWidth:"1160px",height:"900px"}}>
        <div className="layer__bottom__head mb15">
          <div className="layer__pop__title" style={{paddingTop:"20px"}}>수료증</div>
          <div className="layer__pop__close" onClick={()=>setMakePDFFile(false)}></div>
        </div>
        <div className="layer__pop__body"> 
          <div className="main-box" style={varMakeList.length===0?{display:"none"}:{visibility:"hidden"}}>
            <canvas ref={canvaskrRef} width={560} height={700} style={{border:"solid 1px #eee"}}/>
          </div>
          <div className="main-box" style={varMakeList.length===0?{display:"none"}:{visibility:"hidden"}}>
            <canvas ref={canvasenRef} width={1100} height={720} style={{border:"solid 1px #eee"}}/>
          </div>
          <div className="pdf-con">
          {varFileList.map((files,i)=>(
            <div key={'files_'+i}>
              <img src={files.image} alt=""/>
            </div>
          ))}
          </div>
        </div>
        <div className="btn-center">
          <button onClick={e=>MakePDFFile(e)} style={{width:"130px"}} className="btn">PDF로 저장</button>
          <button onClick={()=>setMakePDFFile(false)} style={{width:"90px"}} className="btn line">닫기</button>
        </div>
      </div>
    </div>
  )
}
export default MakePDFCertifications;